module.exports = __webpack_public_path__ + "img/05.20040212.png";